'use client';

import { Fragment } from 'react';
import { momentParse, timeRange, dateAndTimeRange } from '../../utils/time';
import PopoverIcon from '../popover-icon';
import type { Event } from '../../types/Event';

type Props = {
  event?: Event;
  fullDate?: boolean;
  [key: string]: unknown;
};

const EventTime = ({ event, fullDate = false, ...otherProps }: Props) => {
  if (!event.startAt) {
    return <div>TBD</div>;
  }

  const startAt = momentParse(event.startAt, event.timezone);
  const endAt = event.endAt ? momentParse(event.endAt, event.timezone) : null;
  const details = event.startAtDetails;

  return (
    <Fragment>
      <time
        dateTime={startAt.toString()}
        title={startAt.format('dddd, MMMM Do, YYYY h:mm a')}
        {...otherProps}
      >
        {fullDate ? dateAndTimeRange(startAt, endAt) : timeRange(startAt, endAt)}
      </time>
      {details && <PopoverIcon>{details}</PopoverIcon>}
    </Fragment>
  );
};

export default EventTime;
